/** Libellés accessibles pour boutons icône (sans texte visible). */
export const COMMON_UI_I18N_PART2_SLICE_E = {
	iconButtonAccessibilityLabels: {
		closeDialog: "Fermer la fenêtre",
		closeNotification: "Fermer la notification",
		downloadDocument: "Télécharger le document",
		removeFile: "Retirer le fichier",
		openMainMenu: "Ouvrir le menu principal",
		closeMainMenu: "Fermer le menu principal",
		openNotifications: "Ouvrir les notifications",
		openUserMenu: "Ouvrir le menu utilisateur",
		removeChip: "Retirer l'élément",
		moreActions: "Plus d'actions",
		edit: "Modifier",
		delete: "Supprimer",
		archiveDocument: "Archiver le document",
		publishSiteText: "Publier le texte",
		archiveSiteText: "Archiver le texte",
		revokeShare: "Révoquer le partage",
		selectCustomer: "Sélectionner ce client",
		removeCustomer: "Retirer ce client",
		selectThirdParty: "Sélectionner ce tiers",
		removeThirdParty: "Retirer ce tiers",
		selectConfrere: "Sélectionner ce confrère",
		removeConfrere: "Retirer ce confrère",
		goToFolder: "Accéder au dossier",
		incidentReportNav: "Accéder au formulaire de signalement d'incident",
		viewDocumentNav: "Consulter le document",
		viewDocumentUnavailable: "Document indisponible — dates au survol",
		downloadDocumentUnavailable: "Téléchargement indisponible — dates au survol",
		sendEmailReminderNav: "Accéder à l'envoi de relance par e-mail",
		reminderHistoryNav: "Voir l'historique des relances",
		formFieldCopyValue: "Copier la valeur du champ",
		formFieldTogglePasswordVisibility: "Afficher ou masquer le mot de passe",
		toggleControl: "Basculer",
		toastOpenLinkedContent: "Ouvrir le contenu lié à cette notification",
	},
} as const;
